/**
 * @generated SignedSource<<82dfd601b6c007ddb98a52bb7d6a991e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddCommentReactionInput = {
  commentId: string;
  emoji: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type addCommentReactionMutation$variables = {
  input: AddCommentReactionInput;
};
export type addCommentReactionMutation$data = {
  readonly addCommentReaction: {
    readonly comment: {
      readonly id: string;
      readonly reactions: ReadonlyArray<{
        readonly emoji: string;
        readonly count: number;
        readonly viewerHasReacted: boolean;
        readonly persons: ReadonlyArray<{
          readonly id: string;
          readonly fullName: string | null;
        }>;
      }>;
    } | null;
  } | null;
};
export type addCommentReactionMutation = {
  variables: addCommentReactionMutation$variables;
  response: addCommentReactionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddCommentReactionPayload",
    "kind": "LinkedField",
    "name": "addCommentReaction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CommentType",
        "kind": "LinkedField",
        "name": "comment",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CommentReactionType",
            "kind": "LinkedField",
            "name": "reactions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emoji",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerHasReacted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "persons",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addCommentReactionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addCommentReactionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9372ea3359e6ab4ccea7569ecfafec61",
    "id": null,
    "metadata": {},
    "name": "addCommentReactionMutation",
    "operationKind": "mutation",
    "text": "mutation addCommentReactionMutation(\n  $input: AddCommentReactionInput!\n) {\n  addCommentReaction(input: $input) {\n    comment {\n      id\n      reactions {\n        emoji\n        count\n        viewerHasReacted\n        persons {\n          id\n          fullName\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d407ba6212bc4c224df1195e48d8e48";

export default node;
